import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { BuilderService } from '../builder-services/builder.service'
import { SettingsApiService } from 'src/app/builder-services/api/settings.api.service'

@Injectable({
  providedIn: 'root'
})
export class SubscribersService {
  constructor(
    private builderService: BuilderService,
    private settingsApi: SettingsApiService
  ) {}

  submitSubscriber = (subscriber: any, subscriber_id: string = '') => {
    subscriber = JSON.parse(JSON.stringify(subscriber))
    const key = subscriber_id || String(Date.now())
    return new Observable<any>((observer) => {
      this.settingsApi.upsertSettingsByType(String(this.builderService.selectedProject), 'subscribers', { [key]: JSON.stringify(subscriber) })
        .then(() => {
          observer.next({ key }) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable
        })
        .catch((error) => {
          observer.error(error) // Notify the observer of an error
        })
    })
  }

  getSubscribers = () => {
    return new Observable<any>((observer) => {
      this.settingsApi.getSettingsByType(String(this.builderService.selectedProject), 'subscribers').then(
        (response) => {
          if (!response || !Object.keys(response).length) {
            console.log('No data available')
            observer.next({})
            observer.complete() // Complete the Observable
          } else {
            const parsed: Record<string, any> = {}
            for (const [k, v] of Object.entries(response)) {
              try { parsed[k] = typeof v === 'string' ? JSON.parse(v) : v } catch { parsed[k] = v }
            }
            observer.next(parsed) // Notify the observer that the operation is complete
            observer.complete() // Complete the Observable
          }
        }
      ).catch((error) => {
        observer.error(error) // Notify the observer of an error
      })
    })
  }

  getSubscriber = (subscriber_id: string) => {
    return new Observable<any>((observer) => {
      this.settingsApi.getSettingsByType(String(this.builderService.selectedProject), 'subscribers').then(
        (response) => {
          const raw = response[subscriber_id]
          if (raw) {
            let parsed = raw
            try { if (typeof raw === 'string') parsed = JSON.parse(raw) } catch {}
            observer.next(parsed) // Notify the observer that the operation is complete
            observer.complete() // Complete the Observable
          } else {
            console.log('No data available')
            observer.next({})
            observer.complete() // Complete the Observable
          }
        }
      ).catch((error) => {
        observer.error(error) // Notify the observer of an error
      })
    })
  }

  removeSubscriber = (subscriber_id: string) => {
    return new Observable<any>((observer) => {
      this.settingsApi.upsertSettingsByType(String(this.builderService.selectedProject), 'subscribers', { [subscriber_id]: null as any })
        .then(() => {
          observer.next(null) // Notify the observer that the operation is complete
          observer.complete() // Complete the Observable
        })
    })
  }
}
